import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Chip,
  Grid,
} from '@mui/material';
import type { ConsultationResponseDto } from '../types/consultation';

interface ConsultationViewProps {
  consultation: ConsultationResponseDto;
}

const ConsultationView: React.FC<ConsultationViewProps> = ({ consultation }) => {
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Consultation Details
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      {consultation.questions && consultation.questions.length > 0 && (
        <Box mt={4}>
          <Typography variant="subtitle1" gutterBottom>
            Health Questionnaire
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <List dense>
            {consultation.questions.map((question, index) => (
              <ListItem key={index} disableGutters>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={question.answer}
                    tabIndex={-1}
                    disableRipple
                    disabled
                  />
                </ListItemIcon>
                <ListItemText
                  primary={question.question}
                  secondary={question.notes || 'No additional notes'}
                  secondaryTypographyProps={{
                    sx: {
                      whiteSpace: 'pre-line',
                      fontStyle: question.notes ? 'normal' : 'italic',
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box mb={3}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Chief Complaint
            </Typography>
            <Typography paragraph>{consultation.chiefComplaint}</Typography>
          </Box>

          <Box mb={3}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              History of Present Illness
            </Typography>
            <Typography paragraph sx={{ whiteSpace: 'pre-line' }}>
              {consultation.historyOfPresentIllness}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box mb={3}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Diagnosis
            </Typography>
            <Typography paragraph>{consultation.diagnosis}</Typography>
          </Box>

          {consultation.notes && (
            <Box mb={3}>
              <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                Additional Notes
              </Typography>
              <Typography paragraph sx={{ whiteSpace: 'pre-line' }}>
                {consultation.notes}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>

    </Paper>
  );
};

export default ConsultationView;
